import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/live_stream.jpg'


const _hoisted_1 = { class: "live_stream_container" }
const _hoisted_2 = { class: "broad_list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "list_tag" }
const _hoisted_5 = {
  key: 0,
  class: "no_end"
}
const _hoisted_6 = {
  key: 1,
  class: "is_end"
}
const _hoisted_7 = {
  key: 2,
  class: "is_end"
}
const _hoisted_8 = { class: "item_img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "img",
  src: _imports_0,
  alt: ""
}
const _hoisted_11 = { class: "item_content" }
const _hoisted_12 = { class: "content_title" }
const _hoisted_13 = { class: "content_author" }
const _hoisted_14 = { class: "content_time" }
const _hoisted_15 = {
  key: 0,
  class: "item_btn"
}
const _hoisted_16 = {
  key: 1,
  class: "item_btn item_btn1"
}
const _hoisted_17 = {
  key: 2,
  class: "item_btn item_btn2"
}
const _hoisted_18 = { key: 1 }

import { onMounted, ref } from 'vue'
import NavBar from '@/components/NavBar.vue'
import TabBar from '@/components/TabBar.vue'
import { Sticky, List, showToast, Loading } from 'vant'
import { getLivestreamList, getLivestreamRedirect } from '@/api/requests/LiveStream'
import PullToRefresh from '@/components/PullToRefresh.vue'
import { Record } from '@/api/Models/LiveRoomList'
import Error from '@/components/Error.vue'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { isFeishu } from '@/utils/feishu'
import { isApp } from '@/utils/client'
import { isWechat } from '@/utils/weixin'
import { isTudoApp } from '@/utils/tudo'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isOutFieldApp } from '@/utils/outfield'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isSandsTalkMiddleEastApp } from '@/utils/sandsTalkMEOutfiled'
import { isSandsTalkBrMexApp } from '@/utils/sandsTalkBRMXOutfiled'


const __default__ = {
  name: 'liveStream'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "v6582918e": (_unref(themeColor))
}))

const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()

const tabDate = ref([
  { title: t('app_all'), name: null },
  { title: t('app_in_live'), name: 1 },
  { title: t('app_not_started'), name: 2 },
  { title: t('app_ended'), name: 3 }
])
const status = ref()
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const current = ref(1)
const total = ref(0)
const pageSize = ref(15)
const listData = ref<Record[]>([])

const liveStreamList = async () => {
  const res = await getLivestreamList({
    current: current.value,
    keyWord: '',
    size: pageSize.value,
    status: status.value
  })
  if (refreshing.value) {
    refreshing.value = false
  }
  const { code, data } = res
  loading.value = false
  if (code === 1) {
    if (current.value === 1) {
      total.value = Math.ceil(data.total / pageSize.value)
      listData.value = data.records
    } else {
      listData.value.push(...data.records)
    }
    if (current.value >= total.value) {
      finished.value = true
    } else {
      current.value++
    }
  }
}

const onLoad = () => {
  liveStreamList()
}

const onRefresh = () => {
  finished.value = false
  loading.value = true
  current.value = 1
  liveStreamList()
}

const upTab = (name: number) => {
  status.value = name
  onRefresh()
}

onMounted(() => {
  liveStreamList()
})

// 直播/回放/回放生成中
const watchLiveStream = async (item: Record) => {
  const isPlayback = item.status === 3 && item.coursewareId
  const isPlaybackGenerating = item.status === 3 && !item.coursewareId
  const isLiveStream = item.status === 1 || item.status === 2
  if (isLiveStream) {
    router.push({ name: 'live', query: { watchUrl: item.watchUrl } })
  }
  try {
    const res = await getLivestreamRedirect({
      id: item.id,
      type: 0
    })
    if (res) {
      if (isPlayback) {
        if (item.isAllowPlayback === 1) {
          // 回放状态 跳转课件
          router.push({
            name: 'courseDetail',
            query: {
              id: item.coursewareId,
              courseType: 'courseWare',
              channel: 5,
              title: item.name
            }
          })
          return
        }
      }
      if (isPlaybackGenerating) {
        if (item.isAllowPlayback === 1) {
          showToast(t('app_live_stream_replay_generation'))
          return
        }
        if (item.isAllowPlayback === 0) {
          return
        }
      }
    } else {
      // 你还没有该直播间的访问权限，请向管理员申请
      showToast(t('app_no_live_stream_permission'))
      router.replace({ path: '/empty', query: { msg: t('app_no_live_stream_permission') } })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}

const pullRefreshHeight =
  !isFeishu &&
  !isApp &&
  !isWechat &&
  !isTudoApp &&
  !isWisdomRabbitApp &&
  !isOutFieldApp &&
  !isBranchManagerApp &&
  !isSandsTalkFlutterApp &&
  !isSandsTalkMSFlutterApp &&
  !isSandsTalkPhOutfieldApp &&
  !isSandsTalkMiddleEastApp &&
  !isSandsTalkBrMexApp
    ? 'calc(100vh - 88px)'
    : 'calc(100vh - 44px)'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Sticky), null, {
      default: _withCtx(() => [
        _createVNode(NavBar),
        _createVNode(TabBar, {
          tabDate: tabDate.value,
          onUpTab: upTab
        }, null, 8, ["tabDate"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PullToRefresh, {
        refreshing: refreshing.value,
        "onUpdate:refreshing": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh,
        "min-height": _unref(pullRefreshHeight)
      }, {
        default: _withCtx(() => [
          (listData.value.length > 0)
            ? (_openBlock(), _createBlock(_unref(List), {
                key: 0,
                loading: loading.value,
                "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
                finished: finished.value,
                "finished-text": listData.value && listData.value.length > pageSize.value ? `-  ${_ctx.$t('app_class_room_bottom')} -` : ' ',
                onLoad: onLoad
              }, {
                loading: _withCtx(() => [
                  (listData.value && listData.value.length > pageSize.value)
                    ? (_openBlock(), _createBlock(_unref(Loading), {
                        key: 0,
                        type: "spinner"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(' ')))
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "list_wrapper"
                    }, [
                      _createElementVNode("div", {
                        class: "list_item",
                        onClick: ($event: any) => (watchLiveStream(item))
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          (item.status === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('app_in_live')), 1))
                            : (item.status === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('app_not_started')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('app_ended')), 1)),
                          _createElementVNode("div", _hoisted_8, [
                            (item.coverFileUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "img",
                                  src: item.coverFileUrl,
                                  alt: ""
                                }, null, 8, _hoisted_9))
                              : (_openBlock(), _createElementBlock("img", _hoisted_10))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(item.lecturerName), 1),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(item.startTime), 1)
                        ]),
                        (item.status === 1 || item.status === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('app_live_stream_watch')), 1))
                          : _createCommentVNode("", true),
                        (item.status === 3 && item.isAllowPlayback === 1 && item.coursewareId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('app_live_stream_playback')), 1))
                          : _createCommentVNode("", true),
                        (item.status === 3 && !item.coursewareId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('app_live_stream_playback')), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_3)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["loading", "finished", "finished-text"]))
            : (_openBlock(), _createBlock(Error, {
                key: 1,
                selfStyle: { backgroundColor: '#fff', width: '100%' }
              }))
        ]),
        _: 1
      }, 8, ["refreshing", "min-height"])
    ])
  ]))
}
}

})